export default __webpack_public_path__ + "static/media/line.af7cca95.svg";